/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuccessMedicationHistorySyncStatusResponse } from '../models/SuccessMedicationHistorySyncStatusResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ConnectiveHealthMedicationHistoryControllerService {

    /**
     * Provide whether the member's pharmacy medication history is being retrieved
     * Reflects the member's most recent medication history request to the health information exchange. The app shows the member that tasks may be completed automatically while the request is pending.
     * @returns SuccessMedicationHistorySyncStatusResponse The state of the most recent request, or NOT_REQUESTED
     * @throws ApiError
     */
    public static medicationHistorySyncStatus(): CancelablePromise<SuccessMedicationHistorySyncStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/users/me/connectivehealth/medication-history',
            errors: {
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

}
